import { CreateButton } from '@app/modules/audit/modules/reports/definitions/update/components/actions/CreateButton';
import { ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE } from '@app/modules/audit/routing/admin-audit-paths';
import { useParams } from 'react-router-dom';
import { AUDIT_TEMPLATE_REPORT_TYPES } from './audit-template-report-types';

/**
 * Page-header create action for the active template report-type chip.
 */
export function AuditTemplatesCreateAction() {
  const { reportType } = useParams<{ reportType?: string }>();
  const activeType =
    reportType && (AUDIT_TEMPLATE_REPORT_TYPES as readonly string[]).includes(reportType)
      ? reportType
      : ADMIN_AUDIT_DEFAULT_TEMPLATE_TYPE;

  return <CreateButton reportType={activeType} />;
}
